import React, { useContext, useState } from 'react'
import { useChannelWithNormalGifFetch } from 'shared/api/channels'
import AddFeaturedGifOverlay from 'shared/components/add-featured-gif-overaly'
import ChannelPageContext from 'shared/components/context/channel-page'
import GridTypeContext from 'shared/components/context/grid-type'
import Grid from 'shared/components/grid'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import { grid5, grid9 } from 'shared/util/grid'
import { getAllTheCopy } from 'shared/util/string'
import styled from 'styled-components'
import Feed from '../feed'
import Navigation from './navigation'

const Container = styled.div`
    margin-top: 30px;
`

const NoResults = styled.div`
    background: url('/static/img/shrug.gif') no-repeat center center;
    background-size: contain;
    height: 300px;
    margin: 0 auto;
    width: ${grid5}px;
`

const ChannelGrid = () => {
    const { channel, channelType, searchQuery } = useContext(ChannelPageContext)
    // we'll wait till this is fetched before showing the tv
    const [noResults, showNoResults] = useState<boolean | undefined>(undefined)
    const { id, display_name: displayName, has_children: hasChildren, content_type: contentType, user } = channel
    const { gridType } = useContext(GridTypeContext)
    const isFeaturedTag = channelType === 'tagged_channel'
    let fetchOptions
    if (channelType === 'tagged_channel' || channelType === 'search_channel') {
        fetchOptions = { term: searchQuery, isFeaturedTag }
    }
    const fetchGifs = useChannelWithNormalGifFetch(id, 'gifs', fetchOptions)
    // fetches are cached in memory so no need to worry about the extra fetch
    const testForGifs = useChannelWithNormalGifFetch(id, 'gifs', fetchOptions)
    useAsyncEffect(async () => {
        const result = await testForGifs(0)
        showNoResults(result.data.length === 0)
    }, [])
    const isVerified = user?.is_verified || user?.user_type === 'partner' || user?.user_type === 'artist'
    const showTv = noResults === false && isVerified && !searchQuery && !isFeaturedTag
    const title = searchQuery || isFeaturedTag || !hasChildren ? '' : getAllTheCopy(displayName, contentType)
    if (noResults === undefined) {
        return null
    }
    return (
        <Container>
            <Navigation title={title} noResults={noResults} />
            {gridType === 'feed' ? (
                <Feed fetchGifs={fetchGifs} />
            ) : (
                <>
                    <Grid
                        Overlay={AddFeaturedGifOverlay}
                        fetchGifs={fetchGifs}
                        width={grid9}
                        tvConfig={showTv ? { align: 'left', channels: [id] } : undefined}
                    />
                </>
            )}
            {noResults && <NoResults />}
        </Container>
    )
}

export default ChannelGrid
